var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#twitter_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.86 7.869 6.329-7.2h-1.5l-5.498 6.25L5.803.67H.74l6.638 9.452L.74 17.669h1.5l5.802-6.6 4.636 6.6h5.062M2.78 1.776h2.304l10.604 14.841h-2.304",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "twitter_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.74 .67)",
    d: "M0 0h17v17H0z"
  })))));
};
export default SvgTwitter;